import { render, staticRenderFns } from "./SupplierDetailCard.vue?vue&type=template&id=5e522e21&lang=pug&"
import script from "./SupplierDetailCard.vue?vue&type=script&lang=js&"
export * from "./SupplierDetailCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports